import { Box, Tab, TabList, TabPanel, Tabs, Typography } from "@mui/joy";
import React from "react";
import TicketListing from "./TicketListing";
import { useLocation, useNavigate } from "react-router-dom";

interface TicketingPortalProps {
	selected: number;
}

const tabPanelSx = {
	p: 2,
	flex: 1,
	minHeight: 0,
	overflow: "auto",
	backgroundColor: "background.body",
	"&[hidden]": { display: "none" },
	"&:not([hidden])": { display: "flex", flexDirection: "column" },
};

export default function TicketingPortal(props: TicketingPortalProps) {
	const [idx, setIdx] = React.useState(props.selected);
	const location = useLocation();
	const navigate = useNavigate();

	React.useEffect(() => {
		const pathToIdx: Record<string, number> = {
			alltickets: 0,
			sales: 1,
		};
		const x = location.pathname.toLowerCase().replace("/", "");
		if (pathToIdx[x] !== undefined) {
			setIdx(pathToIdx[x]);
		}
	}, [location]);

	const onTabChange = (_event: React.SyntheticEvent | null, value: number | string | null) => {
		const next = value as number;
		setIdx(next);
		navigate(next === 0 ? "/alltickets" : "/sales");
	};

	return (
		<Box sx={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0, backgroundColor: "background.surface", border: "1px solid", borderColor: "divider" }}>
			<Box sx={{ px: 2, pt: 2, pb: 0 }}>
				<Typography level="h3" sx={{ mb: 1.5 }}>
					Tickets
				</Typography>
			</Box>
			<Tabs value={idx} onChange={onTabChange} sx={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
				<TabList sx={{ px: 2, gap: 0.5, borderBottom: "1px solid", borderColor: "divider", boxShadow: "none" }}>
					<Tab color={idx === 0 ? "primary" : "neutral"} value={0}>
						All Tickets
					</Tab>
					<Tab color={idx === 1 ? "primary" : "neutral"} value={1}>
						Sales Tickets
					</Tab>
				</TabList>
				<TabPanel value={0} sx={tabPanelSx}>
					<TicketListing />
				</TabPanel>
				<TabPanel value={1} sx={tabPanelSx}>
					<TicketListing sales={true} />
				</TabPanel>
			</Tabs>
		</Box>
	);
}